const HIDDEN_ROUTE_PREFIXES = [
  "/agent/",
  "/live-agent/",
  "/genie/",
  "/activate/",
  "/launch/",
  "/get/",
];

declare global {
  interface Window {
    HelpGenieV2?: { init: (config: Record<string, unknown>) => void };
  }
}

export const isSiteWidgetHiddenPath = (pathname: string): boolean =>
  HIDDEN_ROUTE_PREFIXES.some((prefix) => pathname.startsWith(prefix));

export const shouldLoadSiteWidget = (): boolean => {
  if (window.self !== window.top) return false;
  if (isSiteWidgetHiddenPath(window.location.pathname)) return false;
  if (new URLSearchParams(window.location.search).get("embed") === "true")
    return false;
  return (
    window.location.hostname !== "localhost" &&
    window.location.hostname !== "127.0.0.1"
  );
};

/** Loads the global site widget only after private URL values have been scrubbed. */
export const loadSiteWidget = () => {
  if (!shouldLoadSiteWidget() || window.HelpGenieV2) return;
  if (document.querySelector('script[data-help-genie-site-widget="true"]'))
    return;

  const origin = window.location.origin || "https://helpgenie.ai";
  const script = document.createElement("script");
  script.src = `${origin}/widget-v2.js`;
  script.async = true;
  script.dataset.helpGenieSiteWidget = "true";
  script.onload = () => {
    window.HelpGenieV2?.init({
      agentUrl: "genie-help",
      baseUrl: origin,
      position: "bottom-right",
      primaryColor: "#6c8ff2",
      title: "Genie Help",
      subtitle: "Voice or text, your call",
      avatarIconUrl:
        "https://vdskjkjxyeehklwxnhrf.supabase.co/storage/v1/object/public/genie-images/s12rkeo-1754377048642.png",
      peekoutText: "Got a question? Just ask",
    });
  };
  document.head.appendChild(script);
};
